import { ACTIVE_AUDIO_NODE_STORE } from '../globals';
export const isPassiveAudioNode = (audioNode) => {
    return !ACTIVE_AUDIO_NODE_STORE.has(audioNode);
};
//# sourceMappingURL=is-passive-audio-node.js.map